import React from "react";
import { TurnrCard, TurnrCardHeader } from "~/components/card/TurnrCard";
import EntityActionsDotsMenu from "~/components/entityAction/EntityActionsDotsMenu.jsx";
import EntityList from "~/components/entityAction/EntityList.js";
import { TurnrGrid } from "~/components/TurnrGrid.jsx";
import { serviceIsLoading, serviceIsSuccessfullyFetched } from "rylak-common";
import { EntityActionCreateButtonBigCard } from "~/components/entityAction/EntityActionCreateButton.jsx";
import styles from "./EntityListCards.module.scss";
import { TurnrTooltip } from "rylak-common/src/components/TurnrTooltip/TurnrTooltip.jsx";
import { TOOLTIP_TEXTS } from "~/constants.jsx";

export function EntityCardPriorityHeader({ children, entity, priority = entity?.priority, priorityTooltipPortalRef }) {
    return (
        <>
            <div
                style={{
                    position: "absolute",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    top: "-10px",
                }}
            >
                <TurnrCard
                    style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <TurnrTooltip style={{ zIndex: 1 }} portalRef={priorityTooltipPortalRef} title={"Priority: " + priority} content={TOOLTIP_TEXTS.PRICE_SETUP_PRIORITY}>
                        <div
                            style={{
                                width: "24px",
                                height: "24px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <div
                                style={{
                                    // width: "24px",
                                    // height: "24px",
                                    fontSize: "13px",
                                }}
                            >
                                {priority}
                            </div>
                        </div>
                    </TurnrTooltip>
                </TurnrCard>
                <div
                    style={{
                        width: "27px",
                        height: "17px",
                        top: "10px",
                        borderRadius: "0px 0px 20px 20px",
                        background: "white",
                        position: "absolute",
                    }}
                ></div>
            </div>
            <TurnrCardHeader>
                {/*MarginRight because of dots-menu*/}
                <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginRight: "40px", minHeight: "16px" }}>{children}</div>
            </TurnrCardHeader>
        </>
    );
}

function EntityCard(props) {
    const { appProps, entity, onSuccess, EntityContentComponent, readOnly, entityContentComponentProps, initialLanguageCode } = props;
    return (
        <TurnrCard
            style={{ height: "100%", overflow: "visible" }}
            buttons={!readOnly && [<EntityActionsDotsMenu key={0} appProps={appProps} entity={entity} onSuccess={onSuccess} initialLanguageCode={initialLanguageCode} />]}
        >
            <EntityContentComponent appProps={appProps} entity={entity} {...entityContentComponentProps} />
        </TurnrCard>
    );
}

function EntityCardsRenderer(props) {
    const { appProps, entities, onSuccess, EntityContentComponent, entityContentComponentProps, entitiesActionsServiceData, loading, initialLanguageCode } = props;
    return (
        <TurnrGrid container spacing={1}>
            <TurnrGrid item xs={12}>
                <div className={styles["cards-wrapper"]}>
                    {entities?.map((entity) => {
                        return (
                            <EntityCard
                                key={entity.id}
                                appProps={appProps}
                                entity={entity}
                                EntityContentComponent={EntityContentComponent}
                                entityContentComponentProps={entityContentComponentProps}
                                onSuccess={onSuccess}
                                readOnly={false}
                                initialLanguageCode={initialLanguageCode}
                            />
                        );
                    })}
                    {!loading && serviceIsSuccessfullyFetched(entitiesActionsServiceData) && (
                        <EntityActionCreateButtonBigCard appProps={appProps} onSuccess={onSuccess} entityActionsServiceData={entitiesActionsServiceData} initialLanguageCode={initialLanguageCode} />
                    )}
                    {loading && <TurnrCard loading={true} loadingMinHeight={"270px"} />}
                    {serviceIsLoading(entitiesActionsServiceData) && <TurnrCard loading={true} loadingMinHeight={"270px"} />}
                </div>
            </TurnrGrid>
        </TurnrGrid>
    );
}

export default function EntityListCards(props) {
    return <EntityList {...props} Entity description={null} title={null} Renderer={EntityCardsRenderer} />;
}
